import { Component } from "react";
import _ from "underscore";
import Button from "@material-ui/core/Button";
import TableNew, { CELL_TYPES } from "../../../shared/Table";
import SendInformationButton from "./SendInformationButton";

class SoldLoansBulkUploadComponent extends Component {
  constructor(props) {
    super(props);

    this.state = {
      Batch: [],
      Failed: [],
      uploaded: false,
      open: false,
    };
  }

  UNSAFE_componentWillReceiveProps = (props) => {
    if (props.soldLoans) {
      if (
        this.props.soldLoans.registeringId != null &&
        props.soldLoans.registeringError
      )
        this.manageError();
      else if (
        this.props.soldLoans.registeringId != null &&
        props.soldLoans.lastRegisteredId != null
      )
        this.manageSuccess();
    }
  };

  manageError = () => {
    let itemToRemove = _.findIndex(this.state.Batch, (x) => {
      return x.OCR === this.props.soldLoans.registeringId;
    });

    this.setState({
      Failed: this.state.Failed.concat(this.state.Batch[itemToRemove]),
      Batch: [
        ...this.state.Batch.slice(0, itemToRemove),
        ...this.state.Batch.slice(itemToRemove + 1),
      ],
    });
  };

  manageSuccess = () => {
    let itemToRemove = _.findIndex(this.state.Batch, (x) => {
      return x.OCR === this.props.soldLoans.registeringId;
    });

    this.setState({
      Batch: [
        ...this.state.Batch.slice(0, itemToRemove),
        ...this.state.Batch.slice(itemToRemove + 1),
      ],
    });
  };

  getSoldLoanAmountByOCR = (OCR) => {
    let soldLoan = _.find(this.props.soldLoans.data, (item) => {
      return item.OCR === OCR;
    });

    if (soldLoan && soldLoan.DueAndOverdue && soldLoan.DueAndOverdue.Amount)
      return soldLoan.DueAndOverdue.Amount;
    else return "OCR_NOT_MATCHED";
  };

  getOCRByCreditId = (creditId) => {
    let soldLoan = _.find(this.props.soldLoans.data, (item) => {
      return item.Id === creditId;
    });

    if (soldLoan) return soldLoan.OCR;
    else return "OCR_NOT_MATCHED";
  };

  getLoanIdByCreditId = (creditId) => {
    let soldLoan = _.find(this.props.soldLoans.data, (item) => {
      return item.Id === creditId;
    });

    if (soldLoan) return soldLoan.IntId;
    else return "OCR_NOT_MATCHED";
  };

  csv2json = (csv) => {
    let lines = csv.split("\r\n");
    let result = [];
    let headers = lines[0].split(";");

    for (let i = 1; i < lines.length; i++) {
      let obj = {};
      let currentLine = lines[i].split(";");

      for (let j = 0; j < headers.length; j++) {
        obj[headers[j]] = currentLine[j];
      }

      if (currentLine.length !== headers.length) obj.Failed = true;

      result.push(obj);
    }

    return result; //JavaScript object
  };

  getSoldLoansDataFromFile = (event) => {
    let that = this;
    let file = event.target.files[0];

    let reader = new FileReader();
    reader.onload = (e) => {
      let data = e.target.result;
      let json = this.csv2json(data);
      let newJson = [];
      let failed = [];
      for (let item of json) {
        item.creditId = item.CreditID.replace('="', "").replace('"', "");
        item.OCR = that.getOCRByCreditId(item.creditId);
        item.loanId = that.getLoanIdByCreditId(item.creditId);
        //item.amount = that.getSoldLoanAmountByOCR(item.OCR);

        if (item.BankReceiveDate)
          item.bankReceiveDate = item.BankReceiveDate.replace('="', "").replace(
            '"',
            "",
          );
        else item.bankReceiveDate = new Date().toISOString();

        if (item.OCR !== "OCR_NOT_MATCHED") newJson.push(item);
        else failed.push(item);
      }

      this.setState({
        Batch: newJson,
        Failed: failed,
        uploaded: true,
      });
    };
    reader.readAsBinaryString(file);
  };

  getSoldLoansDataFromFileLabel = () =>
    this.state.uploaded ? "File uploaded" : "Upload file";

  clearBatches = () =>
    this.setState({ ...this.state, Batch: [], Failed: [], uploaded: false });

  getCompletedColumns = () => {
    return [
      {
        key: "CreditID",
        label: "Credit ID",
        visible: true,
        type: CELL_TYPES.text,
      },
      {
        key: "SoldDate",
        label: "Sold Date",
        visible: true,
        type: CELL_TYPES.date,
      },
      {
        key: "PaymentReceivedDate",
        label: "Payment received date",
        visible: true,
        type: CELL_TYPES.date,
      },
      {
        key: "SoldAmount",
        label: "Sold amount",
        visible: true,
        type: CELL_TYPES.money,
      },
      {
        key: "OriginalAmount",
        label: "Original amount",
        visible: true,
        type: CELL_TYPES.money,
      },
      {
        key: "Capital",
        label: "Capital",
        visible: true,
        type: CELL_TYPES.money,
      },
      {
        key: "Interest",
        label: "Interest",
        visible: true,
        type: CELL_TYPES.money,
      },
      {
        key: "Intermediation",
        label: "Intermediation",
        visible: true,
        type: CELL_TYPES.money,
      },
      {
        key: "Invoice",
        label: "Invoice",
        visible: true,
        type: CELL_TYPES.money,
      },
      {
        key: "Reminder",
        label: "Reminder",
        visible: true,
        type: CELL_TYPES.money,
      },
      {
        key: "Penalty",
        label: "Penalty",
        visible: true,
        type: CELL_TYPES.money,
      },
      { key: "OCR", label: "OCR", visible: true, type: CELL_TYPES.text },
      {
        key: "bankReceiveDate",
        label: "bank receive date",
        visible: true,
        type: CELL_TYPES.date,
      },
    ];
  };

  render = () => (
    <div>
      <h3>Bulk upload:</h3>
      <div>
        <Button
          component="label"
          variant="contained"
          color="primary"
          fullWidth={false}
          style={{ width: "35%", margin: "0 5px 5px 0" }}
        >
          {this.getSoldLoansDataFromFileLabel()}
          <input
            id="fileSoldLoans"
            type="file"
            style={{ display: "none" }}
            onChange={this.getSoldLoansDataFromFile}
          />
        </Button>
        <SendInformationButton
          {...this.props}
          payments={this.state.Batch}
        ></SendInformationButton>

        <Button
          component="label"
          variant="outlined"
          fullWidth={false}
          style={{ width: "35%" }}
          onClick={this.clearBatches}
        >
          Clear batches
        </Button>
      </div>
      <div>
        Batch to send: <br />
        <TableNew
          items={this.state.Batch}
          columns={this.getCompletedColumns()}
          tableKey="BatchToSendSoldSoans"
        />
        <br />
        Batch not sent: <br />
        <TableNew
          items={this.state.Failed}
          columns={this.getCompletedColumns()}
          tableKey="BatchNotSendSoldSoans"
        />
      </div>
    </div>
  );
}

export default SoldLoansBulkUploadComponent;
